import { render, staticRenderFns } from "./CarDefectUpload.vue?vue&type=template&id=5d20c13f&scoped=true&"
import script from "./CarDefectUpload.vue?vue&type=script&lang=ts&"
export * from "./CarDefectUpload.vue?vue&type=script&lang=ts&"
import style0 from "./CarDefectUpload.vue?vue&type=style&index=0&id=5d20c13f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d20c13f",
  null
  
)

export default component.exports